import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/shared/Button';

const Pricing = () => {
    const navigate = useNavigate();

    const plans = [
        {
            name: 'Başlangıç',
            price: '₺1.490',
            period: '/ay',
            description: 'Küçük ve orta ölçekli depolar için ideal.',
            features: [
                '5 Rampa Yönetimi',
                'Sınırsız Nakliyeci Kaydı',
                'Temel Raporlama',
                'Email Bildirimleri',
                '7/24 Destek'
            ],
            color: 'rgba(255, 255, 255, 0.7)',
            buttonVariant: 'secondary'
        },
        {
            name: 'Profesyonel',
            price: '₺3.990',
            period: '/ay',
            description: 'Birden fazla deposu olan fabrikalar için.',
            features: [
                '20 Rampa Yönetimi',
                'Gelişmiş Gecikme Analizi',
                'SMS & Push Bildirimleri',
                'Excel Export Özelliği',
                'Öncelikli Destek'
            ],
            color: '#3772ff',
            buttonVariant: 'primary',
            popular: true
        },
        {
            name: 'Enterprise',
            price: 'Özel',
            period: '',
            description: 'Global lojistik ağları ve büyük tesisler için.',
            features: [
                'Sınırsız Rampa & Depo',
                'API Entegrasyonları',
                'Custom Claims Yetkilendirme',
                'Özel Eğitim ve Onboarding',
                'Dedicated Hesap Yönetimi'
            ],
            color: '#8b5cf6',
            buttonVariant: 'secondary'
        }
    ];

    return (
        <div className="flex flex-col items-center" style={{
            minHeight: '100vh',
            background: '#030303',
            padding: 'var(--spacing-2xl) var(--spacing-md)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Background Effects */}
            <div style={{
                position: 'absolute',
                top: '-10%',
                right: '-5%',
                width: '60%',
                height: '60%',
                background: 'radial-gradient(circle, rgba(55, 114, 255, 0.05) 0%, transparent 70%)',
                filter: 'blur(80px)',
                zIndex: 0
            }}></div>

            <div className="text-center mb-2xl" style={{ maxWidth: '800px', position: 'relative', zIndex: 1 }}>
                <h1 style={{
                    fontSize: '3.5rem',
                    fontWeight: '800',
                    marginBottom: '20px',
                    letterSpacing: '-2px',
                    color: 'white',
                    background: 'linear-gradient(to bottom, #fff, #888)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                }}>
                    Geleceğin Lojistiğini Şeffafça Yönetin
                </h1>
                <p style={{ fontSize: '1.2rem', color: 'rgba(255, 255, 255, 0.5)', lineHeight: '1.6' }}>
                    Depo süreçlerinizi modernize edin, gecikmeleri minimize edin ve verimliliği artırın. <br />
                    Sizin için en uygun paketi seçerek hemen başlayın.
                </p>
            </div>

            <div className="container" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
                gap: '24px',
                maxWidth: '1200px',
                width: '100%',
                position: 'relative',
                zIndex: 1
            }}>
                {plans.map((plan, index) => (
                    <div
                        key={index}
                        className="card-premium"
                        style={{
                            position: 'relative',
                            padding: '40px',
                            display: 'flex',
                            flexDirection: 'column',
                            background: plan.popular ? 'rgba(12, 12, 12, 0.9)' : '#0c0c0c',
                            border: plan.popular ? '1px solid #3772ff' : '1px solid rgba(255, 255, 255, 0.05)',
                            boxShadow: plan.popular ? '0 0 40px rgba(55, 114, 255, 0.15)' : '0 20px 40px rgba(0,0,0,0.4)',
                            transition: 'transform 0.3s ease',
                            transition: 'transform 0.3s ease'
                        }}
                    >
                        {plan.popular && (
                            <div style={{
                                position: 'absolute',
                                top: '20px',
                                right: '20px',
                                background: 'linear-gradient(135deg, #3772ff 0%, #0044ff 100%)',
                                color: 'white',
                                padding: '4px 12px',
                                borderRadius: '20px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                boxShadow: '0 4px 12px rgba(55, 114, 255, 0.3)'
                            }}>
                                EN POPÜLER
                            </div>
                        )}

                        <div style={{ marginBottom: '40px' }}>
                            <h3 style={{ color: plan.color, marginBottom: '8px', fontSize: '1.2rem', fontWeight: '700' }}>{plan.name}</h3>
                            <div className="flex items-end gap-xs">
                                <span style={{ fontSize: '3rem', fontWeight: '800', color: 'white' }}>{plan.price}</span>
                                <span style={{ color: 'rgba(255,255,255,0.4)', marginBottom: '12px', fontSize: '1.1rem' }}>{plan.period}</span>
                            </div>
                            <p style={{ color: 'rgba(255,255,255,0.5)', marginTop: '16px', fontSize: '14px', lineHeight: '1.5' }}>{plan.description}</p>
                        </div>

                        <div className="flex flex-col gap-md mb-2xl" style={{ flex: 1 }}>
                            {plan.features.map((feature, fIndex) => (
                                <div key={fIndex} className="flex items-center gap-sm" style={{ fontSize: '14px', color: 'rgba(255, 255, 255, 0.7)' }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={plan.popular ? '#3772ff' : 'rgba(255,255,255,0.3)'} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    {feature}
                                </div>
                            ))}
                        </div>

                        <Button
                            variant={plan.buttonVariant}
                            onClick={() => navigate(`/register?plan=${plan.name.toLowerCase()}`)}
                            style={{
                                width: '100%',
                                padding: '16px',
                                fontWeight: 'bold',
                                background: plan.popular ? 'linear-gradient(135deg, #3772ff 0%, #0044ff 100%)' : 'rgba(255,255,255,0.05)',
                                color: 'white',
                                border: plan.popular ? 'none' : '1px solid rgba(255,255,255,0.1)'
                            }}
                        >
                            Hemen Başla
                        </Button>
                    </div>
                ))}
            </div>

            <div className="mt-2xl text-center" style={{ position: 'relative', zIndex: 1 }}>
                <p style={{ color: 'rgba(255, 255, 255, 0.4)' }}>
                    Büyük bir kuruluş musunuz? <a href="#" style={{ color: '#3772ff', fontWeight: 'bold', textDecoration: 'none' }}>Satış ekibimizle görüşün</a>
                </p>
                <button
                    onClick={() => navigate('/login')}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: 'rgba(255,255,255,0.3)',
                        marginTop: '24px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        margin: '24px auto 0'
                    }}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                    Giriş Sayfasına Dön
                </button>
            </div>
        </div>
    );
};

export default Pricing;
